const config: any = {
  rowSelection: false,
  fieldControl: false,
  search: false,
  toolbar: false,
  pagination: false,
  columns: [
    {
      title: '任务类型',
      dataIndex: 'typeCodeDesc',
      width: 110,
    },
    {
      title: '任务名称',
      dataIndex: 'longTitle',
      ellipsis: true,
      width: 160,
    },
    {
      title: '发起人',
      dataIndex: 'createdBy',
      width: 120,
    },
    {
      title: '发起时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      ellipsis: true,
      width: 80,
    },
    {
      title: '状态',
      dataIndex: 'stateCode',
      render: 'stateCodeFn',
      width: 80,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 150,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  footer: false,
}
export default config
